import { ErrorFaultStateModel } from 'models/ErrorFaultState';
import { ErrorFault } from "models/ErrorFault";
import {logService} from 'services/Services';

export type ErrorFaultAction =
  | { type: "add_error"; payload: ErrorFault}
  | { type: "remove_error"; payload: ErrorFault };

export const errorFaultReducer = (state: ErrorFaultStateModel, action: ErrorFaultAction) : ErrorFaultStateModel => {
    switch (action.type)
    {
        case 'add_error':
            let _errorFault = action.payload;

            const log = logService.postLog(_errorFault);
            let _errorFaults = [...state.errorFaults, _errorFault]
            return {...state, errorFaults: _errorFaults };
        case 'remove_error' :
            // const updateToasts = state.toasts?.filter(
            //     //(toast) => toast.id !== action.
            // );
            return {...state };
        default:
            return state;
    }
};